<template>
  <RkTable :data="shareholderList" :loading="loading" :finished="finished">
    <RkTableColumn prop="holderName" label="股东名称" fixed align="left" :width="`${postcssPatch(120)}`">
      <template #default="{ row }">{{ $digitjs(row.holderName).isNull() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="holdingNumber" label="持股数量" :width="`${postcssPatch(90)}`">
      <template #default="{ row }">{{ $digitjs(row.holdingNumber).convert() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="holdingRatio" label="持股比例" :width="`${postcssPatch(90)}`">
      <template #default="{ row }">{{ $digitjs(row.holdingRatio).unit('%').rounded() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="changeNumber" label="变动股数" :width="`${postcssPatch(120)}`">
      <template #default="{ row }">
        <span :style="{ color: $digitjs(row.changeNumber).color() }">{{
          $digitjs(row.changeNumber).prefix().convert()
        }}</span>
      </template>
    </RkTableColumn>
    <RkTableColumn prop="holdingType" label="持股种类" :width="`${postcssPatch(120)}`">
      <template #default="{ row }">{{ $digitjs(row.holdingType).isNull() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="reportDate" label="发布日期" :width="`${postcssPatch(100)}`">
      <template #default="{ row }">{{ $digitjs(row.reportDate).isNull() }}</template>
    </RkTableColumn>
  </RkTable>
</template>

<script>
import { postcssPatch } from '@/utils/postcssPatch'

export default {
  data() {
    return {
      loading: false,
      finished: false,
      shareholderList: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    }
  },
  created() {
    this.getShareholderList()
  },
  methods: {
    postcssPatch,
    async getShareholderList() {
      this.loading = true
      const res = await this.$post(this.$api.f10.hk + '/summary/holders-equity-details', {
        symbol: this.symbol
      })
      const data = res.data ?? []
      this.shareholderList = data.sort((a, b) => b.holdingRatio - a.holdingRatio)
      this.finished = true
      this.loading = false
    }
  }
}
</script>
